/**
 * @fileoverview Model representing Apple Business data.
 *
 * @author Michael Zhang (jinzhang@yext.com)
 */

export class AppleBusiness {
  /**
   * @param {{
   *  displayName: string,
   *  appleBusinessId: string,
   * }} params
   */
  constructor(params) {
    /** @type {string} */
    this.displayName = params.displayName;
    /** @type {string} */
    this.appleBusinessId = params.appleBusinessId;
  }

  /**
   * @param {!AppleBusinessJson} json
   * @return {!AppleBusiness}
   */
  static fromJSON(json) {
    return new AppleBusiness({
      displayName: json['displayName'],
      appleBusinessId: json['appleBusinessId'],
    });
  }
}

/**
 * @dict
 * @typedef {{
 *  displayName: string,
 *  appleBusinessId: string,
 * }}
 */
export var AppleBusinessJson;
